import { CSSProperties } from 'react'

type StyleValue = CSSProperties | undefined | null | false

export function StyleEx(...styles: StyleValue[]): CSSProperties {
  return Object.assign({}, ...styles.filter(Boolean))
}
